import React from "react";
import { Link } from "react-router-dom";
import { Mail, Linkedin, MapPin } from "lucide-react";
import { PmnLogo } from "@/components/PmnLogo";
import { FOOTER_DESCRIPTION } from "@/data/site";

export function Footer() {
  return (
    <footer className="bg-charcoal text-paper">
      <div className="mx-auto max-w-8xl px-6 py-20 lg:px-10">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <PmnLogo size={30} tone="#F5F3EE" />
              <span className="font-serif text-xl tracking-wideish">Project Management Network</span>
            </div>
            <p className="mt-6 max-w-sm text-sm leading-[1.8] text-paper/60">
              {FOOTER_DESCRIPTION}
            </p>
          </div>

          <div className="lg:col-span-3">
            <p className="text-xs uppercase tracking-mega text-teal-light">Navigate</p>
            <ul className="mt-6 space-y-3 text-sm text-paper/70">
              {[["Home", "/"], ["Services", "/services"], ["Capabilities", "/capabilities"], ["Case Studies", "/case-studies"], ["About", "/about"], ["Contact", "/contact"]].map(
                ([label, to]) => (
                  <li key={to}>
                    <Link to={to} className="link-underline" data-testid={`footer-${label.toLowerCase()}`}>
                      {label}
                    </Link>
                  </li>
                )
              )}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <p className="text-xs uppercase tracking-mega text-teal-light">Contact</p>
            <ul className="mt-6 space-y-4 text-sm text-paper/70">
              <li className="flex items-center gap-3">
                <Mail className="h-4 w-4 text-teal-light" strokeWidth={1.25} />
                <a href="mailto:brandon@pmnetwork.org" className="link-underline" data-testid="footer-email">
                  brandon@pmnetwork.org
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Linkedin className="h-4 w-4 text-teal-light" strokeWidth={1.25} />
                <a
                  href="https://www.linkedin.com/company/project-management-network-pm-network/"
                  target="_blank"
                  rel="noreferrer"
                  className="link-underline"
                  data-testid="footer-linkedin"
                >
                  LinkedIn
                </a>
              </li>
              <li className="flex items-center gap-3">
                <MapPin className="h-4 w-4 text-teal-light" strokeWidth={1.25} />
                Dallas–Fort Worth, Texas
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-paper/10 pt-8 text-xs tracking-wideish text-paper/60 sm:flex-row sm:items-center">
          <p>© {new Date().getFullYear()} Project Management Network. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <Link to="/privacy" className="link-underline" data-testid="footer-privacy">
              Privacy
            </Link>
            <Link to="/admin/login" className="link-underline" data-testid="footer-admin">
              Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
